const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN || '';

export const STATE_CENTERS = {
  AL: { lat: 32.806671, lng: -86.79113, zoom: 6 },
  AK: { lat: 61.370716, lng: -152.404419, zoom: 4 },
  AZ: { lat: 33.729759, lng: -111.431221, zoom: 6 },
  AR: { lat: 34.969704, lng: -92.373123, zoom: 6 },
  CA: { lat: 36.116203, lng: -119.681564, zoom: 5 },
  CO: { lat: 39.113014, lng: -105.358887, zoom: 6 },
  CT: { lat: 41.597782, lng: -72.755371, zoom: 8 },
  DE: { lat: 39.318523, lng: -75.507141, zoom: 8 },
  DC: { lat: 38.897438, lng: -77.026817, zoom: 10 },
  FL: { lat: 27.9944024, lng: -81.7602544, zoom: 6 },
  GA: { lat: 32.1656, lng: -82.9001, zoom: 6 },
  HI: { lat: 21.094318, lng: -157.498337, zoom: 7 },
  ID: { lat: 44.240459, lng: -114.478828, zoom: 5 },
  IL: { lat: 40.0631, lng: -89.3397, zoom: 6 },
  IN: { lat: 39.849426, lng: -86.258278, zoom: 6 },
  IA: { lat: 42.011539, lng: -93.210526, zoom: 6 },
  KS: { lat: 38.5266, lng: -96.726486, zoom: 6 },
  KY: { lat: 37.66814, lng: -84.670067, zoom: 6 },
  LA: { lat: 31.169546, lng: -91.867805, zoom: 6 },
  ME: { lat: 44.693947, lng: -69.381927, zoom: 6 },
  MD: { lat: 39.063946, lng: -76.802101, zoom: 7 },
  MA: { lat: 42.230171, lng: -71.530106, zoom: 7 },
  MI: { lat: 43.326618, lng: -84.536095, zoom: 6 },
  MN: { lat: 45.694454, lng: -93.900192, zoom: 6 },
  MS: { lat: 32.741646, lng: -89.678696, zoom: 6 },
  MO: { lat: 38.456085, lng: -92.288368, zoom: 6 },
  MT: { lat: 46.921925, lng: -110.454353, zoom: 5 },
  NE: { lat: 41.12537, lng: -98.268082, zoom: 6 },
  NV: { lat: 38.313515, lng: -117.055374, zoom: 5 },
  NH: { lat: 43.452492, lng: -71.563896, zoom: 7 },
  NJ: { lat: 40.298904, lng: -74.521011, zoom: 7 },
  NM: { lat: 34.3071, lng: -106.0186, zoom: 6 },
  NY: { lat: 42.9543, lng: -75.5262, zoom: 6 },
  NC: { lat: 35.630066, lng: -79.806419, zoom: 6 },
  ND: { lat: 47.528912, lng: -99.784012, zoom: 6 },
  OH: { lat: 40.388783, lng: -82.764915, zoom: 6 },
  OK: { lat: 35.565342, lng: -96.928917, zoom: 6 },
  OR: { lat: 43.8041, lng: -120.5542, zoom: 6 },
  PA: { lat: 40.590752, lng: -77.209755, zoom: 6 },
  RI: { lat: 41.680893, lng: -71.51178, zoom: 9 },
  SC: { lat: 33.856892, lng: -80.945007, zoom: 7 },
  SD: { lat: 44.299782, lng: -99.438828, zoom: 6 },
  TN: { lat: 35.747845, lng: -86.692345, zoom: 6 },
  TX: { lat: 31.054487, lng: -99.5632, zoom: 5 },
  UT: { lat: 40.150032, lng: -111.862434, zoom: 6 },
  VT: { lat: 44.045876, lng: -72.710686, zoom: 7 },
  VA: { lat: 37.769337, lng: -78.169968, zoom: 6 },
  WA: { lat: 47.4009, lng: -120.588, zoom: 6 },
  WV: { lat: 38.491226, lng: -80.954453, zoom: 7 },
  WI: { lat: 44.268543, lng: -89.616508, zoom: 6 },
  WY: { lat: 42.755966, lng: -107.30249, zoom: 6 },
};

const countyCenterCache = new Map();

const STATE_SERVICE_FALLBACKS = {
  CO: { lat: 39.7392, lng: -104.9903, zoom: 10 },
  FL: { lat: 28.2919557, lng: -81.4075713, zoom: 11 },
};

const KNOWN_COUNTY_CENTERS = {
  CO: {
    Adams: { lat: 39.8743, lng: -104.3363 },
    Arapahoe: { lat: 39.6203, lng: -104.3326 },
    Boulder: { lat: 40.0945, lng: -105.3577 },
    Broomfield: { lat: 39.9205, lng: -105.0867 },
    Denver: { lat: 39.7392, lng: -104.9903 },
    Douglas: { lat: 39.3297, lng: -104.9298 },
    Elbert: { lat: 39.2866, lng: -104.1359 },
    Jefferson: { lat: 39.5800, lng: -105.2663 },
    Larimer: { lat: 40.6956, lng: -105.5943 },
    Pueblo: { lat: 38.1736, lng: -104.5122 },
    Weld: { lat: 40.5548, lng: -104.3929 },
  },
  FL: {
    Brevard: { lat: 28.2639, lng: -80.7214 },
    Broward: { lat: 26.1901, lng: -80.3659 },
    Duval: { lat: 30.3322, lng: -81.6557 },
    Hillsborough: { lat: 27.9198, lng: -82.3549 },
    Lake: { lat: 28.7658, lng: -81.7128 },
    'Miami-Dade': { lat: 25.7617, lng: -80.1918 },
    Orange: { lat: 28.4845, lng: -81.2519 },
    Osceola: { lat: 28.0590, lng: -81.1392 },
    'Palm Beach': { lat: 26.7056, lng: -80.0364 },
    Pinellas: { lat: 27.8764, lng: -82.7779 },
    Polk: { lat: 27.8617, lng: -81.6912 },
    Seminole: { lat: 28.7097, lng: -81.2081 },
  },
};

export function getStateCenter(code) {
  if (!code) return null;
  const c = String(code).trim().toUpperCase();
  return STATE_CENTERS[c] || null;
}

export function normalizeServiceCountyName(value) {
  return String(value || '')
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/\s+county$/i, '');
}

export function getServiceAreaCounties(company) {
  const raw = company?.serviceAreas?.counties || company?.serviceAreaCounties || [];
  if (!Array.isArray(raw)) return [];
  const seen = new Set();
  return raw
    .map(normalizeServiceCountyName)
    .filter(Boolean)
    .filter((county) => {
      const key = county.toLowerCase();
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
}

async function geocodeCountyCenter(county, state) {
  const cleanCounty = normalizeServiceCountyName(county);
  const cleanState = String(state || '').trim().toUpperCase();
  if (!cleanCounty || !cleanState) return null;

  const cacheKey = `${cleanCounty.toLowerCase()}|${cleanState}`;
  if (countyCenterCache.has(cacheKey)) return countyCenterCache.get(cacheKey);

  const known = KNOWN_COUNTY_CENTERS[cleanState]?.[cleanCounty];
  if (known) {
    const result = { county: cleanCounty, ...known };
    countyCenterCache.set(cacheKey, result);
    return result;
  }

  if (!MAPBOX_TOKEN) return null;

  try {
    const params = new URLSearchParams({
      access_token: MAPBOX_TOKEN,
      country: 'US',
      limit: '1',
      autocomplete: 'false',
    });
    const query = `${cleanCounty} County, ${cleanState}, USA`;
    const response = await fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?${params}`,
    );
    if (!response.ok) return null;
    const data = await response.json();
    const feature = data?.features?.[0];
    if (!Array.isArray(feature?.center) || feature.center.length < 2) return null;
    const lng = Number(feature.center[0]);
    const lat = Number(feature.center[1]);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    const result = { county: cleanCounty, lat, lng };
    countyCenterCache.set(cacheKey, result);
    return result;
  } catch {
    return null;
  }
}

export async function resolveServiceAreaCenter(company) {
  const state = String(company?.allowedStates?.[0] || 'FL').trim().toUpperCase();
  const stateCenter = getStateCenter(state) || getStateCenter('FL');
  const operationalFallback = STATE_SERVICE_FALLBACKS[state] || {
    lat: stateCenter.lat,
    lng: stateCenter.lng,
    zoom: Math.max(stateCenter.zoom || 6, 9),
  };
  const counties = getServiceAreaCounties(company);

  if (!counties.length) {
    return {
      state,
      counties,
      center: { lat: operationalFallback.lat, lng: operationalFallback.lng },
      zoom: operationalFallback.zoom,
      source: 'state-operational-fallback',
    };
  }

  const geocoded = (await Promise.all(counties.map((county) => geocodeCountyCenter(county, state))))
    .filter(Boolean);

  if (!geocoded.length) {
    return {
      state,
      counties,
      center: { lat: operationalFallback.lat, lng: operationalFallback.lng },
      zoom: operationalFallback.zoom,
      source: 'state-fallback',
    };
  }

  const sum = geocoded.reduce(
    (acc, item) => ({ lat: acc.lat + item.lat, lng: acc.lng + item.lng }),
    { lat: 0, lng: 0 },
  );

  return {
    state,
    counties,
    center: {
      lat: sum.lat / geocoded.length,
      lng: sum.lng / geocoded.length,
    },
    zoom: geocoded.length === 1 ? 11 : geocoded.length <= 4 ? 10 : 9,
    source: 'counties',
  };
}
